import { Link } from "react-router-dom";

import React, { useEffect, useState } from "react";
import { apiRequest } from "../apiService/allapi";
import { successAlert, errorAlert } from "../apiService/sweetAlert";
import { isProductInCart } from "../helper/cartUtils";

const WishlistSection = () => {
  const [wishlistItems, setWishlistItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalPrice, setTotalPrice] = useState(0);

  const getWishlistItems = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      const res = await apiRequest("/Wishlist/getToggle", "GET", null, {
        Authorization: `Bearer ${token}`,
      });
      if (res?.data?.status === true) {
        setWishlistItems(res.data.data || []);
      }
    } catch (error) {
      console.log("Wishlist Error:", error);
      errorAlert("Failed to load wishlist");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getWishlistItems();
  }, []);

  const removeWishlistItem = async (pid) => {
    try {
      const token = localStorage.getItem("token");
    const res = await apiRequest(
      `/Wishlist/DeleteWishlist/${pid}`,   // yaha productId pass hoga
      "DELETE", { pid }, {
        Authorization: `Bearer ${token}`,
      });
      console.log("Remove Response:", res);
      if (res?.data?.status === true) {
        getWishlistItems();
      window.dispatchEvent(new Event("wishlistUpdated"));

        successAlert(res.data.message || "Removed from wishlist");
      }
    } catch (error) {
      console.log("Remove Error:", error);
      errorAlert("Failed to remove item");
    }
  };

  const [loadingId, setLoadingId] = useState(null);

const addToCartFromWishlist = async (pid) => {
  try {
    setLoadingId(pid);

    // 🔥 Check if already in cart
    // const alreadyInCart = await isProductInCart(pid);
    // if (alreadyInCart) {
    //   errorAlert("Out of stock");
    //   setLoadingId(null);
    //   return;
    // }

    const token = localStorage.getItem("token");

    const payload = { pid: pid, qty: 1 };

    const res = await apiRequest("/Cart/add-to-cart", "POST", payload, {
      Authorization: `Bearer ${token}`,
    });

    if (res?.data?.status === true) {

      successAlert(res.data.message);
window.dispatchEvent(new Event("cartCountUpdated"));
      // await removeWishlistItem(pid); // Disabled auto-remove
      getWishlistItems();
    } else {
      errorAlert(res?.data?.message);
    }

  } catch (error) {
    console.log(error);
    errorAlert("Failed to add to cart");
  } finally {
    setLoadingId(null);
  }
};

  const calculateTotal = () => {
    return wishlistItems.reduce((sum, item) => sum + (item.sellingPrice || 0), 0);
  };

  useEffect(() => {
    setTotalPrice(calculateTotal());
  }, [wishlistItems]);

  if (loading) return <div className="text-center py-80"><p>Loading wishlist...</p></div>;

  return (
    <section className="cart py-80">
      <div className="container container-lg">
        <div className="row gy-4">
          {wishlistItems.length === 0 && (
            <div className="text-center py-80">
              <h4>Your Wishlist is Empty ❤️</h4>
              <Link to="/shop" className="btn btn-main mt-16">Continue Shopping</Link>
            </div>
          )}
          <div className="col-xl-9 col-lg-8">
            <div className="cart-table border border-gray-100 rounded-8 px-40 py-48">
              <div className="overflow-x-auto scroll-sm scroll-sm-horizontal">
                <table className="table style-three">
                  {wishlistItems.length > 0 && (
                    <thead>
                      <tr>
                        <th className="h6 mb-0 text-lg fw-bold">Delete</th>
                        <th className="h6 mb-0 text-lg fw-bold">Product Name</th>
                        <th className="h6 mb-0 text-lg fw-bold">Price</th>
                        <th className="h6 mb-0 text-lg fw-bold">Action</th>
                      </tr>
                    </thead>
                  )}
                  <tbody>
                    {wishlistItems.map((item) => (
                      <tr key={item.pid}>
                        <td>
                          <button
                            onClick={() => removeWishlistItem(item.pid)}
                            className="remove-tr-btn flex-align gap-12 hover-text-danger-600"
                          >
                            <i className="ph ph-x-circle text-2xl d-flex" />
                            Remove
                          </button>
                        </td>
                        <td>
                          <div className="table-product d-flex align-items-center gap-24">
                            <div className="table-product__thumb border border-gray-100 rounded-8 flex-center">
                              <img
                                src={`${process.env.REACT_APP_IMAGE_BASE_URL}${item.image}`}
                                alt={item.productName}
                              />
                            </div>
                            <div className="table-product__content text-start">
                              <h6 className="title text-lg fw-semibold mb-8">
                                {item.productName}
                              </h6>
                            </div>
                          </div>
                        </td>
                        <td>
                          <span className="text-lg h6 mb-0 fw-semibold">
                            <del className="text-gray-500 me-8">₹{item.mrp}</del>₹{item.sellingPrice}
                          </span>
                        </td>
                        <td>
                       <button
  onClick={() => addToCartFromWishlist(item.pid)}
  disabled={loadingId === item.pid}
  className="btn btn-main py-12 px-24 rounded-8"
>
  {loadingId === item.pid ? "Adding..." : "Add to Cart"}
</button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          {/* {wishlistItems.length > 0 && (
            <div className="col-xl-3 col-lg-4">
              <div className="cart-sidebar border border-gray-100 rounded-8 px-24 py-40">
                <h6 className="text-xl mb-32">Wishlist Total</h6>
                <div className="bg-color-three rounded-8 p-24">
                  <div className="flex-between gap-8 mb-0">
                    <span className="text-gray-900 text-xl fw-semibold">Total</span>
                    <span className="text-gray-900 text-xl fw-semibold">₹{totalPrice}</span>
                  </div>
                </div>
                <Link to="/cart" className="btn btn-main mt-40 py-18 w-100 rounded-8">
                  View Cart
                </Link>
              </div>
            </div>
          )} */}
        </div>
      </div>
    </section>
  );
};

export default WishlistSection;

